var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.filter.inputs.level.options, function(option) {
        return _c("div", { key: option.value, staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass: "form-label",
              attrs: { for: "level-" + option.value }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.level,
                    expression: "level"
                  }
                ],
                attrs: { type: "radio", id: "level-" + option.value },
                domProps: {
                  value: option.value,
                  checked: _vm._q(_vm.level, option.value)
                },
                on: {
                  change: function($event) {
                    _vm.level = option.value
                  }
                }
              }),
              _vm._v(" \n            " + _vm._s(option.label) + "\n        ")
            ]
          )
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "form-group " }, [
        _c(
          "label",
          { staticClass: "form-label label-block", attrs: { for: "" } },
          [_vm._v(_vm._s(_vm.filter.inputs.campaigns.label))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-input m-0 dblock" },
          _vm._l(_vm.filter.inputs.campaigns.options, function(option) {
            return _c(
              "label",
              {
                key: option.value,
                staticClass: "form-label label-block",
                attrs: { for: "campaign-" + option.value }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.campaigns,
                      expression: "campaigns"
                    }
                  ],
                  attrs: { type: "checkbox", id: "campaign-" + option.value },
                  domProps: {
                    value: option.value,
                    checked: Array.isArray(_vm.campaigns)
                      ? _vm._i(_vm.campaigns, option.value) > -1
                      : _vm.campaigns
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.campaigns,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = option.value,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.campaigns = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.campaigns = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.campaigns = $$c
                      }
                    }
                  }
                }),
                _vm._v(
                  " \n                " +
                    _vm._s(option.label) +
                    "\n            "
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "label",
          { staticClass: "form-label label-block", attrs: { for: "" } },
          [_vm._v(_vm._s(_vm.filter.inputs.consent.label))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-input" },
          _vm._l(_vm.filter.inputs.consent.options, function(option) {
            return _c(
              "label",
              {
                key: option.value,
                staticClass: "form-label label-block",
                attrs: { for: option.value + "-consent" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.consent,
                      expression: "consent"
                    }
                  ],
                  attrs: { type: "radio", id: option.value + "-consent" },
                  domProps: {
                    value: option.value,
                    checked: _vm._q(_vm.consent, option.value)
                  },
                  on: {
                    change: function($event) {
                      _vm.consent = option.value
                    }
                  }
                }),
                _vm._v(
                  " \n                " +
                    _vm._s(option.label) +
                    "\n            "
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm.consent == "with"
        ? _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "form-label", attrs: { for: "" } }, [
              _vm._v(_vm._s(_vm.filter.inputs.date.label))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-input" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.date,
                      expression: "date"
                    }
                  ],
                  attrs: { name: "", id: "" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.date = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.filter.inputs.date.options, function(option) {
                  return _c("option", {
                    key: option.value,
                    domProps: {
                      value: option.value,
                      textContent: _vm._s(option.label)
                    }
                  })
                }),
                0
              )
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }